import React from 'react';
import { Link } from 'react-router-dom';

const Footer: React.FC = () => {
  return (
    <footer className="bg-secondary text-white">
      <div className="container-custom py-12">
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-8 lg:gap-16">
          {/* Column 1: Logo and About */}
          <div className="lg:pr-4">
            <Link to="/" className="flex flex-col items-center">
              <span className="text-2xl font-serif font-bold text-white">Yeremian</span>
              <span className="text-2xl font-serif font-bold text-white">Lifestyle Homes</span>
            </Link>
            <p className="mt-4 text-white text-sm">
              Building quality homes with craftsmanship and care throughout Georgia.
            </p>
          </div>

          {/* Column 2: Quick Links */}
          <div className="lg:px-4">
            <h4 className="text-lg font-semibold mb-4 text-white">Quick Links</h4>
            <ul className="space-y-2">
              <li>
                <Link to="/" className="text-white hover:text-primary transition">Home</Link>
              </li>
              <li>
                <Link to="/about" className="text-white hover:text-primary transition">About Us</Link>
              </li>
              <li>
                <Link to="/warranty" className="text-white hover:text-primary transition">2-10 Warranty</Link>
              </li>
              <li>
                <Link to="/neighborhoods" className="text-white hover:text-primary transition">Neighborhoods</Link>
              </li>
              <li>
                <Link to="/homes" className="text-white hover:text-primary transition">Our Homes</Link>
              </li>
            </ul>
          </div>

          {/* Column 3: Neighborhoods */}
          <div className="lg:px-4">
            <h4 className="text-lg font-semibold mb-4 text-white">Neighborhoods</h4>
            <ul className="space-y-2">
              <li>
                <Link to="/neighborhoods/highlands" className="text-white hover:text-primary transition">
                  The Highlands – Rome, GA
                </Link>
              </li>
              <li>
                <Link to="/neighborhoods/castleberry" className="text-white hover:text-primary transition">
                  Castleberry Ridge – Dawsonville, GA
                </Link>
              </li>
            </ul>
          </div>

          {/* Column 4: Contact Information */}
          <div className="lg:pl-4">
            <h4 className="text-lg font-semibold mb-4 text-white">Contact Us</h4>
            <ul className="space-y-2 text-white">
              <li className="flex items-start">
                <span className="mr-2">📞</span>
                <a href="tel:+14702394911" className="text-white hover:text-primary transition">
                  (470) 239-4911
                </a>
              </li>
            </ul>
          </div>
        </div>
        
        {/* Copyright */}
        <div className="mt-12 pt-8 border-t border-gray-600 text-center text-white text-sm">
          <p>©{new Date().getFullYear()} Yeremian Lifestyle Homes - A Georgia Diversified Services Company</p>
        </div>
      </div>
    </footer>
  );
};

export default Footer; 